import { TranslocoLoader, provideTransloco } from '@jsverse/transloco';
import { Injectable } from '@angular/core';
import { StateTransferService } from '@utils';
import env from '@env';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private stateTransfer: StateTransferService) {}

  async getTranslation(lang: string) {
    // Prevent network call to root file
    if (lang === 'fr' || lang === 'en') return Promise.resolve({});
    const fromServer = this.stateTransfer.get(lang);
    if (fromServer) return fromServer;
    const data = await import(`../assets/i18n/${lang}.json`);
    this.stateTransfer.set(lang, data.default);
    return data.default;
  }
}

const formatting = {
  currency: {
    minimumFractionDigits: 0,
  },
  decimal: {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
};

export const provideTranslocoRoot = () => [
  provideTransloco({
    config: {
      availableLangs: ['fr', 'en'],
      defaultLang: 'fr',
      fallbackLang: 'en',
      reRenderOnLangChange: true,
      prodMode: env.production,
      flatten: {
        aot: env.production,
      },
    },
    loader: TranslocoHttpLoader,
  }),
  provideTranslocoLocale({
    localeConfig: {
      global: formatting,
    },
    langToLocaleMapping: {
      fr: 'fr-FR',
    },
  })
];